// i18n
import { Trans } from 'react-i18next';

// mui
import { alpha, Alert, Box } from '@mui/material';

// icons
import { AutoAwesome as IconAI } from '@mui/icons-material';

// AI accent color shared by the AI surfaces across the app (matches the
// purple used by AiConditionGenerator, CardAiSummary, and DialogDocumentViewer).
const AI_ACCENT = '#7c3aed';

export interface AiDisclaimerBannerProps {
	/** Optional spacing applied to the outer wrapper. */
	sx?: object;
}

/**
 * Full-width informational banner shown above every AI-generated surface in
 * the app. Reads its copy from a single shared i18n key so wording stays
 * uniform across the product.
 */
export const AiDisclaimerBanner = ({ sx }: AiDisclaimerBannerProps) => {
	return (
		<Box sx={sx}>
			<Alert
				icon={<IconAI sx={{ color: AI_ACCENT }} />}
				severity="info"
				variant="outlined"
				sx={{
					width: '100%',
					alignItems: 'flex-start',
					bgcolor: alpha(AI_ACCENT, 0.04),
					borderColor: alpha(AI_ACCENT, 0.3),
					color: 'text.primary',
					'& .MuiAlert-message': { width: '100%' },
				}}>
				<Trans i18nKey="ai.disclaimer.banner" components={{ b: <strong />, i: <em /> }} />
			</Alert>
		</Box>
	);
};
